<div
    class="color-picker"
    (click)="openColorPicker()"
    (keydown.enter)="openColorPicker()"
    tabindex="0">
    <div class="circle" [style.background-color]="currentColor()"></div>
    <span>{{ currentColor() }}</span>
</div>
